document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('a.copy-link')]
    .map((link) => link as HTMLAnchorElement)
    .forEach((link) => {
      const originalHtml = link.innerHTML;

      link.addEventListener('click', async (e) => {
        e.preventDefault();
        await navigator.clipboard.writeText(link.href);

        link.classList.add('text-success');
        link.innerHTML = '<i class="fa-solid fa-check me-2"></i>Link Copied';

        setTimeout(() => {
          link.classList.remove('text-success');
          link.innerHTML = originalHtml;
        }, 2000);
      });
    });
});
